// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import actions from '../../actions-list';
import {getDefaultState} from '../state/date-range';

const updateRegistrationDate = (state, action) =>
    DateRange.update(state, {
        from: {
            $set: action.registrationDateRange.from
        },
        to: {
            $set: action.registrationDateRange.to
        }
    });

const reset = () => getDefaultState();

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_REGISTRATIONS_REVIEW_CRITERIA]: reset,
        [actions.UPDATE_REGISTRATIONS_REVIEW_REGISTRATION_DATE]: updateRegistrationDate
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/registrations-review/reducers/registration-date.js